exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app-offline{position:fixed;top:0;width:100%;height:auto;padding:15px;background:#d17c78;z-index:5002;color:#fff}#app-offline svg{position:absolute;right:15px;top:15px;cursor:pointer}", ""]);

// exports
